import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface EventHotelResort {
	accommInfoId: string;
	tabNm: string;
	benfInfo: string;
	etcInfo: string;
	korNm: string;
	amenityInfo: string;
	restaurantInfo: string;
	activityInfo: string;
	kidsOnlyServ: string;
}

/** ```
 * 행사 가격 정보 조회
 *   `/pkg/event-schedule/{evCd}/hotel-resort`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const key = "useEventHotelResort";
const getPath = (evCd: string): string | null => {
	if (!evCd) return null;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/event-schedule/${evCd}/hotel-resort`;
};

/** ```
 * 행사 가격 정보 조회
 *   `/pkg/event-schedule/{evCd}/hotel-resort`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const useEventHotelResort = (evCd: string, options?: Partial<UseQueryOptions<Response<EventHotelResort[]>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(evCd)],
		queryFn: () => useConfigureAxios({url: getPath(evCd)}).then(r => r.data),
		staleTime: 1000 * 30 * 60,
		...options,
	});

export default useEventHotelResort;
export {getPath, key};
export type {EventHotelResort};
